import { useTheme } from "@up/data";
import { Toast, ToastTitle, UPLink } from "@up/ui";

export const ApplicationRequired = function (props: { title: string }) {
  const theme = useTheme();
  return (
    <div className="max-w-xl">
      <Toast variant="warning">
        <ToastTitle size="large">{props.title}</ToastTitle>
        If you believe this is an error{" "}
        <a className="underline" href={`mailto: ${theme.supportEmail}`}>
          please contact us at {theme.supportEmail}
        </a>
        .
      </Toast>
      <br />

      <UPLink href="/application" className={theme.buttonPrimaryClass}>
        Apply Now
      </UPLink>
    </div>
  );
};
